import spinRoute from '../../router/spinRoute.js';

export default () => [
    {
        path: '/survey',
        component: () => spinRoute.require(import('./surveyHome.vue')),
        //redirect: '/survey/list',
        children: [
            {
                path: '/survey/list',
                component: () => spinRoute.require(import('./views/list.vue'))
            },
            {
                path: '/survey/instance',
                component: () => spinRoute.require(import('./views/instance.vue')),
                meta: { title: '问卷', },
            },
            {
                path: '/survey/stat',
                component: () => spinRoute.require(import('./views/instanceStat.vue')),
                meta: { title: '问卷统计' },
            },
        ],
    },
]
